var styles = {"container":"FormSearch-module_container__Pnnys","searching":"FormSearch-module_searching__KhCla","spinner-border":"FormSearch-module_spinner-border__Mb7fl","isDirty":"FormSearch-module_isDirty__-ZCds","pseudoInline":"FormSearch-module_pseudoInline__AOlR8"};

export { styles as default };
//# sourceMappingURL=FormSearch.module.scss.js.map
